import { useMutation } from "@tanstack/react-query";
import { useAccessToken } from "@/hooks";
import { CustomersApi } from "@/openapi/generated";
import { createAuthenticatedApi } from "@/lib/utils";

interface UseCustomerUpdateParams {
  userId: number;
  tenantId: number;
}

export const useCustomerUpdate = () => {
  const accessToken = useAccessToken();

  const { mutate, mutateAsync, isPending, isSuccess, isError, error } =
    useMutation({
      mutationFn: async ({ userId, tenantId }: UseCustomerUpdateParams) => {
        if (!accessToken) {
          throw new Error("Authentication token is required");
        }

        const service = createAuthenticatedApi(CustomersApi, accessToken);

        await service.apiUsersUserIdCustomerPut({
          userId,
          xTenantID: tenantId,
        });

        return { userId };
      },
    });

  return { mutate, mutateAsync, isPending, isSuccess, isError, error };
};
